/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_SubInputs */

const th_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกทีมในระบบ เปิดดูรายชื่อผู้เล่น ทีมงานผู้ฝึกสอน และโปรแกรมแข่งขัน`)
};

const en_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every squad on the platform. Open one for its roster, coaching staff and fixtures.`)
};

const ja_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録されている全チーム。ロースター、コーチ陣、日程を確認できます。`)
};

const zh_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台上的所有阵容。打开其中一个可查看阵容、教练组和比赛。`)
};

const es_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las plantillas de la plataforma. Abre una para ver su roster, su cuerpo técnico y sus partidos.`)
};

const pt_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os elencos da plataforma. Abra um para ver elenco, comissão técnica e jogos.`)
};

const id_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap skuad di platform. Buka satu untuk skuad, staf pelatih dan pertandingannya.`)
};

const fr_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les effectifs de la plateforme. Ouvrez-en un pour son effectif, son staff et ses matchs.`)
};

const tl_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawat squad sa plataporma. Buksan ang isa para sa squad, coaching staff at mga laro nito.`)
};

const vi_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi đội hình trên nền tảng. Mở một đội để xem đội hình, ban huấn luyện và các trận.`)
};

const ko_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼의 모든 선수단. 하나를 열면 선수단, 코칭스태프, 경기를 볼 수 있습니다.`)
};

const de_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Kader der Plattform. Öffne einen für Kader, Trainerstab und Spiele.`)
};

const ru_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все составы на платформе. Откройте один, чтобы увидеть состав, тренерский штаб и матчи.`)
};

const tr_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformdaki tüm kadrolar. Kadro, teknik ekip ve maçlar için birini açın.`)
};

const it_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le rose della piattaforma. Aprine una per rosa, staff tecnico e partite.`)
};

const pl_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie składy na platformie. Otwórz jeden, aby zobaczyć skład, sztab i mecze.`)
};

const uk_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі склади на платформі. Відкрийте один, щоб побачити склад, тренерський штаб і матчі.`)
};

const hi_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म की सभी टीमें। टीम, कोचिंग स्टाफ़ और मैच देखने के लिए कोई एक खोलें।`)
};

const ar_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل التشكيلات على المنصّة. افتح واحدة لترى التشكيلة والجهاز الفني والمباريات.`)
};

const ms_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap skuad di platform. Buka satu untuk skuad, kakitangan kejurulatihan dan perlawanannya.`)
};

const bn_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্ল্যাটফর্মের সব দল। দল, কোচিং স্টাফ ও খেলা দেখতে একটি খুলুন।`)
};

const zh_tw2_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台上的所有名單。開啟其中一個可查看名單、教練團與比賽。`)
};

const zh_hk2_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台上的所有名單。開啟其中一個可查看名單、教練團與比賽。`)
};

const ur_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پلیٹ فارم کے تمام اسکواڈ۔ اسکواڈ، کوچنگ اسٹاف اور میچ دیکھنے کے لیے کوئی ایک کھولیں۔`)
};

const fa_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همهٔ فهرست‌های تیمی پلتفرم. یکی را باز کنید تا فهرست تیم، کادر فنی و بازی‌ها را ببینید.`)
};

const sw_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vikosi vyote kwenye jukwaa. Fungua kimoja ili kuona kikosi, wakufunzi na michezo.`)
};

const nl_teams_sub = /** @type {(inputs: Teams_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle selecties op het platform. Open er een voor de selectie, de staf en de wedstrijden.`)
};

/**
* | output |
* | --- |
* | "Every squad on the platform. Open one for its roster, coaching staff and fixtures." |
*
* @param {Teams_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const teams_sub = /** @type {((inputs?: Teams_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_teams_sub(inputs)
	if (locale === "ja") return ja_teams_sub(inputs)
	if (locale === "zh") return zh_teams_sub(inputs)
	if (locale === "es") return es_teams_sub(inputs)
	if (locale === "pt") return pt_teams_sub(inputs)
	if (locale === "id") return id_teams_sub(inputs)
	if (locale === "fr") return fr_teams_sub(inputs)
	if (locale === "tl") return tl_teams_sub(inputs)
	if (locale === "vi") return vi_teams_sub(inputs)
	if (locale === "ko") return ko_teams_sub(inputs)
	if (locale === "de") return de_teams_sub(inputs)
	if (locale === "ru") return ru_teams_sub(inputs)
	if (locale === "tr") return tr_teams_sub(inputs)
	if (locale === "it") return it_teams_sub(inputs)
	if (locale === "pl") return pl_teams_sub(inputs)
	if (locale === "uk") return uk_teams_sub(inputs)
	if (locale === "hi") return hi_teams_sub(inputs)
	if (locale === "ar") return ar_teams_sub(inputs)
	if (locale === "ms") return ms_teams_sub(inputs)
	if (locale === "bn") return bn_teams_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_teams_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_teams_sub(inputs)
	if (locale === "ur") return ur_teams_sub(inputs)
	if (locale === "fa") return fa_teams_sub(inputs)
	if (locale === "sw") return sw_teams_sub(inputs)
	if (locale === "nl") return nl_teams_sub(inputs)
	return en_teams_sub(inputs)
});